export default "__VITE_ASSET__BEuFt5MW__"